import { ServiceFetch } from '../service-fetch'

export default class PromotionGroupModel extends ServiceFetch {
    getPromotionGroupBy = (data) => this.authFetch({
        url: 'promotion-group/getPromotionGroupBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}